import React, { Fragment, useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Faq from "react-faq-component";

import {
  Transaction_Book,
  Transaction_LandingPage,
  Transaction_Register,
} from "../../Connections/Transaction";

import Button from "../../Components/Common/Button";
import Navbar from "../../Components/Navs/NavBar";
import COmment from "../../Components/Common/Comment";
import BookSlider from "../../Components/Common/BookSlider";
import ComponentPoster from "../../Components/Common/ComponentPoster";
import "../../Styles/Landing.css";
import NewSlider from "../../Components/Common/NewSlider";
import InfographicSlider from "../../Components/Common/InfographicSlider";
import MotionDastani from "../../Components/Common/MotionDastani";
import MotionMoarefi from "../../Components/Common/MotionMoarefi";

const Landing = () => {
  const [videoTabState, setVideoTabState] = useState("motion");
  const [awardsList, setAwardsList] = useState([]);
  const [memberOfAchivements, setMemberOfAchivements] = useState({});
  const [selectedBook, setSelectedBook] = useState({});

  const [books, setBooks] = useState([]);
  console.log(books);
  const [supporters, setSupporters] = useState([]);
  const [comrade, setComrade] = useState([]);
  const [media, setMedia] = useState([]);
  const [siteSetting, setSiteSetting] = useState({});
  const [social, setSocial] = useState([]);

  const [FAQ, setFAQ] = useState({});

  const [imgPoster, setImgPoster] = useState();
  const navigator = useNavigate();
  const location = useLocation();

  //context values

  const config = {
    arrowIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="9"
        viewBox="0 0 10 9"
        fill="none"
      >
        <path
          d="M3.63574 3.52364V0.250909H5.7521V3.52364H9.13392V5.55273H5.7521V8.80364H3.63574V5.55273H0.232102V3.52364H3.63574Z"
          fill="#EA15AD"
        />
      </svg>
    ),
    animate: true,
    openOnload: 0,
  };

  // ====================================================

  useEffect(() => {
    Transaction_LandingPage.siteSetting().then((res) => {
      if (res[0]) setSiteSetting(res[2].data);
    });
    Transaction_LandingPage.FAQ().then((res) => {
      if (res[0]) {
        const x = [];
        res[2].data.map((item) => {
          x.push({
            title: <div className="number-font">{item.title}</div>,
            content: <div className="number-font">{item.content}</div>,
          });
        });
        setFAQ({ rows: x });
      }
    });
    Transaction_LandingPage.gift().then((res) => {
      if (res[0]) setAwardsList(res[2].data);
    });
    Transaction_LandingPage.statistics().then((res) => {
      if (res[0]) setMemberOfAchivements(res[2].data);
    });
    Transaction_Book.GetBooks().then((res) => {
      if (res[0]) {
        setBooks(res[2].data);
        setSelectedBook(res[2].data[0]);
      }
    });
    Transaction_LandingPage.media().then((res) => {
      if (res[0]) setMedia(res[2].data);
    });
    Transaction_LandingPage.socialMedia().then((res) => {
      if (res[0]) setSocial(res[2].data);
    });

    Transaction_LandingPage.Supporters().then((res) => {
      if (res[0]) setSupporters(res[2].data);
    });
    Transaction_LandingPage.comrade().then((res) => {
      if (res[0]) setComrade(res[2].data);
    });

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const type = urlParams.get("type") || "shad";

    if (token != null) {
      Transaction_Register.Shad(token, type)
        .then((res) => {
          console.log(res);
          if (res[0]) {
            if (res[1] === "shad") {
              if (localStorage.getItem("Token") === null) {
                localStorage.setItem("shadUserId", res[2].data);
              }
            } else {
              if (localStorage.getItem("Token") === null) {
                localStorage.setItem("Token", res[2].data);
                window.location.reload();
              }
            }
          } else {
            localStorage.removeItem("Token");
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const hnadletohome = () => {
    var s = localStorage.getItem("Token");
    console.log(s);
    if (localStorage.getItem("Token") != null)
      navigator("/hisstori/home", {
        state: {
          prevPath: `${window.location.pathname}`,
        },
      });
    else navigator("/login");
  };

  // ====================================================
  //handle slider modlas
  const [firstSlideToggle, setFirstSlideToggle] = useState(false);
  const [secondSlideToggle, setSecondSlideToggle] = useState(false);

  // ====================================================

  return (
    <Fragment>
      <Navbar />
      <main className="Landing_main">
        <section className="Landing_main-first-section">
          <div className="Landing_main-first-section-right">
            <div className="Landing_main-first-section-right-wrapper">
              <img src="/imgs/Landing/Logo.svg" alt="Ketabino Logo" />
              <p>
                یه ماجراجویی شگفت‌انگیز، ویژه دهه هشتادی‌ها، با ۵ میلیارد تومان
                جایزه!
              </p>
              <div className="login-and-start" onClick={() => hnadletohome()}>
                <Button
                  id={"startEdventure1"}
                  customClass={"start-edventure-btn"}
                  text="شروع ماجراجویی"
                  // link="/hisstori/home"
                />
              </div>
            </div>
          </div>
          <div className="Landing_main-first-section-left">
            <img
              src="/imgs/Landing/Landing-first-section-banner.svg"
              alt="banner image"
            />
          </div>
        </section>
        <section className="Landing_main-second-section">
          <p>
            <img
              src="/imgs/Landing/spiral-arrow.svg"
              alt="spiral arrow"
              className="Landing_main-second-section-img"
            />
            اگه بخوایم روراست باشیم، هیجان‌انگیزترین قسمت هر مسابقه‌ای،
            جایزه‌هاشه! توی هیس‌طوری می‌تونی جایزه‌های خفن نقدی رو بدون
            قرعه‌کشی، فقط با امتیازهایی که کسب می‌کنی برنده شی! میگی نه؟ پایین
            رو بخون...
          </p>
        </section>
        <section className="Landing_main-third-section">
          <div className="Landing_main-third-section-top-row">
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/Awards.svg" alt="" />
              <p>
                <span className="number-font">40</span> میلیون تومان!
              </p>
              <p>جایزه نفر اول</p>
            </div>
            <img src="/imgs/Landing/Awards-arrow.svg" alt="" />
            <div className="Landing_main-third-section-award-wrapper">
              <img src="imgs/Landing/javayez30.svg" alt="" />
              <p>
                <span className="number-font">30</span> میلیون تومان!
              </p>
              <p>جایزه نفر دوم</p>
            </div>
            <img
              src="/imgs/Landing/Awards-arrow.svg"
              alt=""
              className="mobile-hidden"
            />
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/javayez20.svg" alt="" />
              <p>
                <span className="number-font">20</span> میلیون تومان!
              </p>
              <p>جایزه نفر سوم</p>
            </div>
            <img src="/imgs/Landing/Awards-arrow.svg" alt="" />
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/javayez10.svg" alt="" />
              <p>
                <span className="number-font">10</span> میلیون تومان!
              </p>
              <p>جایزه نفرات چهارم تا دهم</p>
            </div>
          </div>
          <div className="Landing_main-third-section-bottom-row">
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/Awardof-11th-to-50th.svg" alt="" />
              <p>
                <span className="number-font">5</span> میلیون تومان!
              </p>
              <p>جایزه نفرات یازدهم تا پنجاهم</p>
            </div>
            <img src="/imgs/Landing/Awards-arrow.svg" alt="" />
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/Like-awards-icon.svg" alt="" />
              <p>
                <span className="number-font">25</span> میلیون تومان!
              </p>
              <p>جایزه دارنده بیشترین تعداد لایک</p>
            </div>
            <img
              src="/imgs/Landing/Awards-arrow.svg"
              alt=""
              className="mobile-hidden"
            />
            <div className="Landing_main-third-section-award-wrapper">
              <img
                src="/imgs/Landing/spiral-arrow.svg"
                alt="spiral arrow"
                className="desktop-hidden Landing_main-third-section-award-wrapper-spiral-arrow"
              />
              <img src="/imgs/Landing/Invite-awards-icon.svg" alt="" />
              <p>
                <span className="number-font">25</span> میلیون تومان!
              </p>
              <p>جایزه بیشترین دعوت کننده به پویش</p>
            </div>
          </div>
        </section>
        <section className="Landing_main-fourth-section">
          <h2>با بیشتر از صدها جایزه دیگه!</h2>
          <div className="Landing_main-fourth-section-awards-wrapper">
            {awardsList.map((award) => (
              <div
                className="Landing_main-fourth-section-awards-item"
                key={award.id}
              >
                <div className="Landing_main-fourth-section-awards-item-info-container">
                  <div className="award-count">
                    <span className="number-font">{award.count}</span> عدد
                  </div>
                  <div className="award-image">
                    <img src={award.src} alt="" />
                  </div>
                </div>
                <h6 className="award-title">{award.Description}</h6>
              </div>
            ))}
          </div>
        </section>
        <section className="Landing_main-fives-section">
          <h2>شروع ماجراجویی</h2>
          <div className="Landing_main_fives-section-adventure-wrapper mobile-hidden">
            <div className="Landing_main_fives-section-adventure-wrapper-top-row">
              <img
                src="/imgs/Landing/Adventure-top-to-bottom-arrow.svg"
                alt=""
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-first-step.svg" alt="" />{" "}
                <p>خوندن کتاب</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-second-step.svg" alt="" />{" "}
                <p>شرکت توی آزمون</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-third-step.svg" alt="" />{" "}
                <p>انجام کنش های هنرمندانه</p>{" "}
              </div>
            </div>
            <div className="Landing_main_fives-section-adventure-wrapper-bottom-row">
              <img
                src="/imgs/Landing/Adventure-top-to-bottom-arrow.svg"
                alt=""
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-fourth-step.svg" alt="" />{" "}
                <p>نظر و واکنش نسبت‌به پست‌ها</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-fiveth-step.svg" alt="" />{" "}
                <p>دریافت امتیاز، سکه و مدال</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-sixth-step.svg" alt="" />{" "}
                <p>
                  دریافت <span> 1111 </span> جایزه نقدی و غیرنقدی <br /> و
                  هزاران کد تخفیف متنوع
                </p>{" "}
              </div>
            </div>
          </div>
          <div className="Landing_main_fives-section-adventure-wrapper-mobile desktop-hidden">
            <div className="Landing_main_fives-section-adventure-wrapper-mobile-top">
              <img
                src="/imgs/Landing/Adventure-top-to-bottom-arrow.svg"
                alt=""
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-first-step.svg" alt="" />{" "}
                <p>خوندن کتاب</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-second-step.svg" alt="" />{" "}
                <p>شرکت توی آزمون</p>{" "}
              </div>
              <img src="/imgs/Landing/Awards-arrow.svg" alt="" />
            </div>
            <div className="Landing_main_fives-section-adventure-wrapper-mobile-second-row">
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-third-step.svg" alt="" />{" "}
                <p>انجام کنش های هنرمندانه</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-fourth-step.svg" alt="" />{" "}
                <p>نظر و واکنش نسبت به پست ها</p>{" "}
              </div>
            </div>
            <div className="Landing_main_fives-section-adventure-wrapper-mobile-third-row">
              <img
                src="/imgs/Landing/Adventure-top-to-bottom-arrow.svg"
                alt=""
                className="first"
              />
              <div className="adventure-step">
                <img src="/imgs/Landing/Adventure-fiveth-step.svg" alt="" />{" "}
                <p>دریافت امتیاز, سکه و مدال</p>{" "}
              </div>
              <img
                src="/imgs/Landing/Adventure-top-to-bottom-arrow.svg"
                alt=""
                className="second"
              />
            </div>
            <div className="Landing_main_fives-section-adventure-wrapper-mobile-bottom">
              <img src="/imgs/Landing/Adventure-sixth-step.svg" alt="" />
              <p>
                دریافت <span> 1111 </span> جایزه نقدی و غیرنقدی <br /> و هزاران
                کد تخفیف متنوع
              </p>
            </div>
          </div>
        </section>
        <section className="Landing_main-sixth-section">
          <h1>تکه‌هایی از هر کتاب</h1>
          <div className="slider-wrapper">
            <BookSlider
              slides={books}
              wrapper_id="poqer3"
              setSelectedBook={setSelectedBook}
              breakPoint={{
                1440: {
                  slidesPerView: 8,
                },
                1428: {
                  slidesPerView: 7,
                },
                1300: {
                  slidesPerView: 7,
                },
                1200: {
                  slidesPerView: 6,
                },
                1000: {
                  slidesPerView: 5,
                },
                992: {
                  slidesPerView: 5,
                },
                800: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
                600: {
                  slidesPerView: 2,
                },
                300: {
                  slidesPerView: 2,
                },
                200: {
                  slidesPerView: 2,
                },
              }}
            />
          </div>
        </section>
        <section className="Landing_main-seventh-section">
          <div className="Landing_main-seventh-section-right">
            <h2>
              {selectedBook?.title}
              <img
                className="Landing_main-seventh-section-right-h2-img"
                src="/imgs/Landing/dots-in-book-banner.svg"
                alt="dots image"
              />
            </h2>
            <p>{selectedBook?.description}</p>
          </div>
          <div className="Landing_main-seventh-section-left">
            <p>برای خوندن کل این متن بیا تو کتابلاگمون!</p>
            <Button
              id={"goKetablog"}
              customClass={"go-ketablog-btn"}
              text="برو به کتابلاگ"
              mobilePosition="right"
              link={"/hisstori/blog"}
            />
          </div>
        </section>
        <section className="Landing_main-eighth-section">
          <div className="Landing_main-eighth-section-top">
            <img
              className="Landing_main-eighth-section-top-particle"
              src="/imgs/Landing/particle.svg"
              alt="particle"
            />
            <div className="Landing_main-eighth-section-top-right">
              <h1>با هیس‌طوری آشنا شو</h1>
              <ul className="Landing_main-eighth-section-top-right-list">
                <li
                  onClick={() => setVideoTabState("tizer")}
                  className={videoTabState == "tizer" ? "active" : ""}
                >
                  تیزر
                </li>
                <li
                  onClick={() => setVideoTabState("poster")}
                  className={videoTabState == "poster" ? "active" : ""}
                >
                  پوستر
                </li>
                <li
                  onClick={() => setVideoTabState("motionMoarefi")}
                  className={videoTabState == "motionMoarefi" ? "active" : ""}
                >
                  موشن معرفی
                </li>

                <li
                  onClick={() => setVideoTabState("infographic")}
                  className={videoTabState == "infographic" ? "active" : ""}
                >
                  اینفوگرافیک
                </li>
                <li
                  onClick={() => setVideoTabState("motion")}
                  className={videoTabState == "motion" ? "active" : ""}
                >
                  موشن داستانی
                </li>
              </ul>

              <div className="video-wrapper">
                {videoTabState == "poster" ? (
                  <>
                    <img
                      src="/imgs/Landing/img-poster.jpg"
                      onClick={() => setImgPoster(!imgPoster)}
                    />
                    {imgPoster ? (
                      <ComponentPoster
                        img={"/imgs/Landing/img-poster.jpg"}
                        close={() => setImgPoster(false)}
                      />
                    ) : null}
                  </>
                ) : videoTabState == "tizer" ? (
                  <iframe
                    src="https://www.aparat.com/video/video/embed/videohash/FHtIc/vt/frame?titleShow=true&recom=self"
                    allowFullScreen="true"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    style={{ width: "100%", height: "100%" }}
                  ></iframe>
                ) : videoTabState == "infographic" ? (
                  <div className="slider-wrapper-infographic">
                    <InfographicSlider
                      // firstSlideToggle={firstSlideToggle}
                      setFirstSlideToggle={setFirstSlideToggle}
                      // secondSlideToggle={secondSlideToggle}
                      setSecondSlideToggle={setSecondSlideToggle}
                      slides={books}
                      wrapper_id="poqer3"
                    />
                    {firstSlideToggle ? (
                      <ComponentPoster
                        img={"/imgs/Landing/HisstoriInfo1.jpg"}
                        className="InfographicSlider_Infographic_img"
                        close={() => setFirstSlideToggle(false)}
                      />
                    ) : null}
                    {secondSlideToggle ? (
                      <ComponentPoster
                        img={"/imgs/Landing/HisstoriInfo2.jpg"}
                        className="InfographicSlider_Infographic_img"
                        close={() => setSecondSlideToggle(false)}
                      />
                    ) : null}
                  </div>
                ) : videoTabState == "motion" ? (
                  <div className="slider-wrapper-MotionDastani">
                    <MotionDastani />
                  </div>
                ) : videoTabState == "motionMoarefi" ? (
                  <div className="slider-wrapper-MotionDastani">
                    <MotionMoarefi slides={books} wrapper_id="poqer3" />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Landing_main-eighth-section-top-left">
              <ul className="Landing_main-eighth-section-top-left-ul">
                <li
                  onClick={() => setVideoTabState("tizer")}
                  className={videoTabState == "tizer" ? "active" : ""}
                >
                  تیزر
                </li>
                <li
                  onClick={() => setVideoTabState("poster")}
                  className={videoTabState == "poster" ? "active" : ""}
                >
                  پوستر
                </li>
                <li
                  onClick={() => setVideoTabState("motionMoarefi")}
                  className={videoTabState == "motionMoarefi" ? "active" : ""}
                >
                  موشن معرفی
                </li>

                <li
                  onClick={() => setVideoTabState("infographic")}
                  className={videoTabState == "infographic" ? "active" : ""}
                >
                  اینفوگرافیک
                </li>
                <li
                  onClick={() => setVideoTabState("motion")}
                  className={videoTabState == "motion" ? "active" : ""}
                >
                  موشن داستانی
                </li>
              </ul>
            </div>
          </div>
          <div className="Landing_main-eighth-section-bottom">
            <div className="Landing_main-eighth-section-bottom-right">
              <p>
                سرگذشت {"<< استعمار >>"} و فاجعه‌های دردناکش یکی از گوشه‌های
                تاریک چند قرن اخیر جهان به‌حساب میاد که فاتحانش تمایلی به افشای
                واقعیتش ندارن و ترجیح میدن همیشه در سکوت باقی بمونه. ما اسم این
                گوشه تاریک و منش بازیگران اصلیش رو گذاشتیم: واقعیت هیس‌طوری!
              </p>
              <div
                className="Landing_main-eighth-section-bottom-right-button"
                onClick={() => hnadletohome()}
              >
                <Button
                  id={"startEdventure2"}
                  customClass={"start-edventure-btn"}
                  text="شروع ماجراجویی"
                  shadowType="inset"
                  // link={"/hisstori/home"}
                />
              </div>
            </div>
            <div className="Landing_main-eighth-section-bottom-left">
              <img src="/imgs/Landing/World-in-dish.svg" alt="World image" />
            </div>
          </div>
        </section>
        <section className="Landing_main-tenth-section">
          <div className="Landing_main-tenth-section-left">
            <img src="/imgs/Landing/Social-banner.svg" alt="Social banner" />
          </div>
          <div className="Landing_main-tenth-section-right">
            <h1>هیس‌طوری رو توی شبکه‌های اجتماعی دنبال کنید!</h1>
            <p>
              برای شرکت توی قرعه‌کشی جایزه‌ها، از اینجا به صفحه‌های هیس‌طوری سر
              بزن.
            </p>
            <div className="social-wrapper">
              {social.map((item) => (
                <a href={item.url} target="_blank" key={item.id}>
                  <img src={item.src} alt={`${item.name} icon`} />
                </a>
              ))}
            </div>
          </div>
        </section>
        <section className="Landing_main-eleventh-section">
          <div className="Landing_main-eleventh-section-content-wrapper">
            <div className="Landing_main-eleventh-section-content-item">
              <p className="Landing_main-eleventh-section-content-item-title number-font">
                {memberOfAchivements.instagram} نفر
              </p>
              <p className="Landing_main-eleventh-section-content-item-description">
                دنبال کننده شبکه های اجتماعی
              </p>
              <div className="Landing_main-eleventh-section-content-item-icon">
                <img src="/imgs/Landing/instagram-icon.svg" alt="" />
              </div>
            </div>
            <div className="Landing_main-eleventh-section-content-item">
              <p className="Landing_main-eleventh-section-content-item-title number-font">
                {memberOfAchivements.history} نفر
              </p>
              <p className="Landing_main-eleventh-section-content-item-description">
                ماجراجو در هیس طوری
              </p>
              <div className="Landing_main-eleventh-section-content-item-icon">
                <img src="/imgs/Landing/Logo.svg" alt="" />
              </div>
            </div>
            <div className="Landing_main-eleventh-section-content-item">
              <p className="Landing_main-eleventh-section-content-item-title number-font">
                {memberOfAchivements.reflects} عنوان
              </p>
              <p className="Landing_main-eleventh-section-content-item-description">
                کنش هنرمندانه
              </p>
              <div className="Landing_main-eleventh-section-content-item-icon">
                <img src="/imgs/Landing/bulb-icon.svg" alt="" />
              </div>
            </div>
            <div className="Landing_main-eleventh-section-content-item">
              <p className="Landing_main-eleventh-section-content-item-title number-font">
                {memberOfAchivements.readBook} صفحه
              </p>
              <p className="Landing_main-eleventh-section-content-item-description">
                خوانده‌شده از کتاب‌ها
              </p>
              <div className="Landing_main-eleventh-section-content-item-icon">
                <img src="/imgs/Landing/book-icon.svg" alt="" />
              </div>
            </div>
            <div className="Landing_main-eleventh-section-content-item">
              <p className="Landing_main-eleventh-section-content-item-title number-font">
                {memberOfAchivements.readTime} دقیقه
              </p>
              <p className="Landing_main-eleventh-section-content-item-description">
                مطالعه‌کتاب‌ها
              </p>
              <div className="Landing_main-eleventh-section-content-item-icon">
                <img src="/imgs/Landing/Time-icon.svg" alt="" />
              </div>
            </div>
          </div>
        </section>
        <section className="Landing_main-twoelfth-section">
          <h1>سوال های پرتکرار</h1>
          <Faq data={FAQ} config={config} />
        </section>
        <section className="Landing_main-thirteenth-section">
          <h1>رسانه ها درباره ما چی میگن؟</h1>
          <div className="slider-wrapper">
            <NewSlider
              contentWidth={"80%"}
              breakPoints={{
                1440: {
                  slidesPerView: 5,
                },
                1300: {
                  slidesPerView: 5,
                },
                1200: {
                  slidesPerView: 4.75,
                },
                1000: {
                  slidesPerView: 4.5,
                },
                992: {
                  slidesPerView: 4.25,
                },
                768: {
                  slidesPerView: 3,
                },
              }}
              slides={media}
              slidesPerView={5}
              autoPlay={false}
              loopToggle={false}
              spaceBetween={25}
            />
          </div>
        </section>
        <section className="Landing_main-fourteenth-section">
          <div className="Landing_main-fourteenth-section-top">
            <img src="/imgs/Landing/book-banner.svg" alt="Book banner" />
            <div className="first-comment Landing_main-fourteenth-section-top-comment-wrapper">
              <COmment
                name="سامان جلیلی"
                text={`واسه من خیلی عجیب بود که این برده‌ها چجوری اونهمه
                                سال قیام نکردن و  اونهمه بدبختی  و مشکلات رو تحمل کردن `}
                img="/imgs/Landing/first-comment-img.png"
                imgSide="right"
              />
            </div>
            <div className="second-comment Landing_main-fourteenth-section-top-comment-wrapper">
              <COmment
                name="آراد باقری"
                text={`داستان هاشو واقعا دوست داشتم طوری بود که نمیشد بی 
                                خیالش بشی و  خیلی جذبت می کرد `}
                img="/imgs/Landing/second-comment-img.png"
                imgSide="right"
              />
            </div>
            <div className="third-comment Landing_main-fourteenth-section-top-comment-wrapper">
              <COmment
                name="علی حسینی فرد"
                text={`به‌نظر من پرتغالی‌ها که شروع‌کننده‌ی این جنایتا بودن
                                از همه بدتر بودن. چون تا قبل از اونا کسی شروع نکرده بود
                                به استعمار وحشیانه‌ی مردم دنیا`}
                img="/imgs/Landing/third-comment-img.png"
                imgSide="left"
              />
            </div>
          </div>
          <div className="Landing_main-fourteenth-section-bottom">
            <div className="Landing_main-fourteenth-section-bottom-icon">
              <img
                src="/imgs/Landing/dots-in-book-banner.svg"
                alt="dots image"
              />
            </div>
            <p className="Landing_main-fourteenth-section-bottom-text">
              برای دیدن نظرهای بیشتر برو به بلاگ
            </p>
            <Button
              id={"goBlog"}
              customClass="go-blog-btn"
              text="بلاگ"
              link={"/hisstori/blog"}
            />
          </div>
        </section>
        <section className="Landing_main-fiveteenth-section">
          <h1>حمایت کنندگان پویش</h1>
          <div className="slider-wrapper">
            <NewSlider
              contentWidth="80%"
              loopToggle={true}
              slides={supporters}
              slidesPerView={6}
              center={false}
              spaceBetween={25}
              breakPoints={{
                1440: {
                  slidesPerView: 6,
                },
                1300: {
                  slidesPerView: 5,
                },
                1200: {
                  slidesPerView: 5,
                },
                1000: {
                  slidesPerView: 4,
                },
                992: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
              }}
              autoPlay={true}
            />
          </div>
        </section>
        <section className="Landing_main-sixteenth-section">
          <h1>همراهان پویش</h1>
          <div className="slider-wrapper">
            <NewSlider
              contentWidth="90%"
              loopToggle={true}
              slides={comrade}
              slidesPerView={6}
              center={false}
              spaceBetween={25}
              breakPoints={{
                1440: {
                  slidesPerView: 6,
                },
                1300: {
                  slidesPerView: 5,
                },
                1200: {
                  slidesPerView: 5,
                },
                1000: {
                  slidesPerView: 4,
                },
                992: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
              }}
              autoPlay={true}
            />
          </div>
        </section>
        <section className="Landing_main-seventeenth-section">
          <div className="Landing_main-seventeenth-section-right">
            <div className="Landing_main-seventeenth-section-right-top">
              <div className="logo-wrapper">
                <img src="/imgs/Landing/logo-dark.svg" alt="Logo" />
              </div>
            </div>
            <div className="Landing_main-seventeenth-section-right-bottom">
              <div className="Landing_main-seventeenth-section-right-bottom-right">
                <p className="Landing_main-seventeenth-section-right-bottom-right-title mobile-hidden">
                  شروع ماجراجویی!
                </p>
                <Link to="/hisstori/blog/Keta-blog">کتاب‌لاگ</Link>
                <Link to="/hisstori/blog/faq">سوالات متداول</Link>
                <Link to="/hisstori/club/invite-friend">همکاری با کتابنو</Link>
                <Link to="/hisstori/blog/term-and-conditions">
                  قوانین و مقررات
                </Link>
                <Link to="/hisstori/blog/introduce">درباره ما</Link>
                <Link to="/hisstori/blog/introduce">تماس با ما</Link>
              </div>
              <div className="Landing_main-seventeenth-section-right-bottom-center-right">
                <div className="compony-info mobile-hidden">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 1 16 16"
                      fill="none"
                    >
                      <path
                        d="M11.0466 14.6668C11.2237 14.6678 11.3992 14.6335 11.5628 14.566C11.7265 14.4985 11.8751 14.399 11.9999 14.2734L13.8066 12.4668C13.9308 12.3419 14.0005 12.1729 14.0005 11.9968C14.0005 11.8206 13.9308 11.6517 13.8066 11.5268L11.1399 8.86009C11.015 8.73593 10.8461 8.66623 10.6699 8.66623C10.4938 8.66623 10.3248 8.73593 10.1999 8.86009L9.13327 9.92009C8.39477 9.72319 7.71081 9.36069 7.13327 8.86009C6.63402 8.28163 6.27169 7.598 6.07327 6.86009L7.13327 5.79343C7.25744 5.66852 7.32714 5.49955 7.32714 5.32343C7.32714 5.1473 7.25744 4.97834 7.13327 4.85343L4.46661 2.18676C4.3417 2.06259 4.17273 1.9929 3.99661 1.9929C3.82048 1.9929 3.65152 2.06259 3.52661 2.18676L1.72661 4.00009C1.60103 4.12492 1.50157 4.27351 1.43404 4.43719C1.36651 4.60087 1.33225 4.77637 1.33327 4.95343C1.39376 7.51496 2.41732 9.95962 4.19994 11.8001C6.04042 13.5827 8.48508 14.6063 11.0466 14.6668ZM3.99994 3.60676L5.72661 5.33343L4.86661 6.19343C4.78515 6.26973 4.72416 6.36525 4.68922 6.47125C4.65427 6.57724 4.6465 6.69031 4.66661 6.80009C4.91579 7.91367 5.44335 8.94586 6.19994 9.80009C7.05351 10.5577 8.08596 11.0854 9.19994 11.3334C9.30806 11.356 9.4201 11.3514 9.52599 11.32C9.63188 11.2886 9.72831 11.2313 9.80661 11.1534L10.6666 10.2734L12.3933 12.0001L11.0599 13.3334C8.84909 13.2765 6.73961 12.3942 5.14661 10.8601C3.60855 9.26643 2.72368 7.15417 2.66661 4.94009L3.99994 3.60676ZM13.3333 7.33343H14.6666C14.6839 6.54076 14.5405 5.7528 14.2451 5.01703C13.9497 4.28126 13.5084 3.61292 12.9477 3.05229C12.3871 2.49166 11.7188 2.05034 10.983 1.75493C10.2472 1.45952 9.45927 1.31614 8.66661 1.33343V2.66676C9.28521 2.64536 9.9016 2.75143 10.4775 2.97838C11.0533 3.20533 11.5764 3.54831 12.014 3.98599C12.4517 4.42367 12.7947 4.9467 13.0217 5.52256C13.2486 6.09843 13.3547 6.71482 13.3333 7.33343Z"
                        fill="#C1C1C1"
                      />
                      <path
                        d="M8.66675 5.33333C10.0667 5.33333 10.6667 5.93333 10.6667 7.33333H12.0001C12.0001 5.18667 10.8134 4 8.66675 4V5.33333Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    مــرکز تماس و پشتیبانی:{" "}
                    {/* <span
                                            className="number-font"
                                            style={{ fontSize: "16px" }}
                                        >
                                            {siteSetting.phone}
                                        </span> */}
                  </p>
                  <div className="number-phone number-font">
                    <p className=" number-font">02166747914</p>
                    <p className="number-font">02166746528</p>
                  </div>
                  <div></div>
                </div>
                <div className="compony-info mobile-hidden">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <path
                        d="M14.2222 3.40918H1.7778C1.54206 3.40918 1.31596 3.49857 1.14927 3.6577C0.982567 3.81682 0.888916 4.03263 0.888916 4.25766V12.7425C0.888916 12.9675 0.982567 13.1834 1.14927 13.3425C1.31596 13.5016 1.54206 13.591 1.7778 13.591H14.2222C14.458 13.591 14.6841 13.5016 14.8508 13.3425C15.0175 13.1834 15.1111 12.9675 15.1111 12.7425V4.25766C15.1111 4.03263 15.0175 3.81682 14.8508 3.6577C14.6841 3.49857 14.458 3.40918 14.2222 3.40918ZM13.5378 12.7425H2.51558L5.62669 9.671L4.98669 9.0813L1.7778 12.2504V4.90251L7.30225 10.1504C7.46879 10.3084 7.69408 10.3971 7.92892 10.3971C8.16375 10.3971 8.38904 10.3084 8.55558 10.1504L14.2222 4.771V12.1952L10.9511 9.07282L10.3245 9.671L13.5378 12.7425ZM2.36003 4.25766H13.5022L7.92892 9.54797L2.36003 4.25766Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    پست الکترونیک:
                    <span className="site-setting">{siteSetting.email}</span>
                  </p>
                </div>
                <div className="social-wrapper">
                  <p className="title">
                    هیس‌طوری رو توی شبکه‌های اجتماعی دنبال کنید!
                  </p>
                  <div className="social">
                    {social.map((item) => (
                      <a
                        className="social-link"
                        href={item.url}
                        key={item.id}
                        target="_blank"
                      >
                        <img src={item.src} alt={`${item.name} icon`} />
                      </a>
                    ))}

                    {/* <a className="social-link">
                                            <img src="imgs/Landing/Social/Aparat.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/twitter.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/instagram.svg" />
                                        </a>
                                        <a>
                                            <img src="imgs/Landing/Social/youtube.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/rubika.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/eee.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/iGap.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/g.svg" />
                                        </a>
                                        <a className="social-link">
                                            <img src="imgs/Landing/Social/aa.svg" />
                                        </a> */}
                  </div>
                </div>
              </div>
              <div className="Landing_main-seventeenth-section-right-bottom-center-left">
                <div className="compony-info desktop-hidden ">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 1 16 16"
                      fill="none"
                    >
                      <path
                        d="M11.0466 14.6668C11.2237 14.6678 11.3992 14.6335 11.5628 14.566C11.7265 14.4985 11.8751 14.399 11.9999 14.2734L13.8066 12.4668C13.9308 12.3419 14.0005 12.1729 14.0005 11.9968C14.0005 11.8206 13.9308 11.6517 13.8066 11.5268L11.1399 8.86009C11.015 8.73593 10.8461 8.66623 10.6699 8.66623C10.4938 8.66623 10.3248 8.73593 10.1999 8.86009L9.13327 9.92009C8.39477 9.72319 7.71081 9.36069 7.13327 8.86009C6.63402 8.28163 6.27169 7.598 6.07327 6.86009L7.13327 5.79343C7.25744 5.66852 7.32714 5.49955 7.32714 5.32343C7.32714 5.1473 7.25744 4.97834 7.13327 4.85343L4.46661 2.18676C4.3417 2.06259 4.17273 1.9929 3.99661 1.9929C3.82048 1.9929 3.65152 2.06259 3.52661 2.18676L1.72661 4.00009C1.60103 4.12492 1.50157 4.27351 1.43404 4.43719C1.36651 4.60087 1.33225 4.77637 1.33327 4.95343C1.39376 7.51496 2.41732 9.95962 4.19994 11.8001C6.04042 13.5827 8.48508 14.6063 11.0466 14.6668ZM3.99994 3.60676L5.72661 5.33343L4.86661 6.19343C4.78515 6.26973 4.72416 6.36525 4.68922 6.47125C4.65427 6.57724 4.6465 6.69031 4.66661 6.80009C4.91579 7.91367 5.44335 8.94586 6.19994 9.80009C7.05351 10.5577 8.08596 11.0854 9.19994 11.3334C9.30806 11.356 9.4201 11.3514 9.52599 11.32C9.63188 11.2886 9.72831 11.2313 9.80661 11.1534L10.6666 10.2734L12.3933 12.0001L11.0599 13.3334C8.84909 13.2765 6.73961 12.3942 5.14661 10.8601C3.60855 9.26643 2.72368 7.15417 2.66661 4.94009L3.99994 3.60676ZM13.3333 7.33343H14.6666C14.6839 6.54076 14.5405 5.7528 14.2451 5.01703C13.9497 4.28126 13.5084 3.61292 12.9477 3.05229C12.3871 2.49166 11.7188 2.05034 10.983 1.75493C10.2472 1.45952 9.45927 1.31614 8.66661 1.33343V2.66676C9.28521 2.64536 9.9016 2.75143 10.4775 2.97838C11.0533 3.20533 11.5764 3.54831 12.014 3.98599C12.4517 4.42367 12.7947 4.9467 13.0217 5.52256C13.2486 6.09843 13.3547 6.71482 13.3333 7.33343Z"
                        fill="#C1C1C1"
                      />
                      <path
                        d="M8.66675 5.33333C10.0667 5.33333 10.6667 5.93333 10.6667 7.33333H12.0001C12.0001 5.18667 10.8134 4 8.66675 4V5.33333Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    مــرکز تماس و پشتیبانی:{" "}
                    {/* <span
                                            className="number-font"
                                            style={{ fontSize: "16px" }}
                                        >
                                            {siteSetting.phone}
                                        </span> */}
                  </p>
                  <div className="number-phone number-font">
                    <p className=" number-font">02166747914</p>
                    <p className="number-font">02166746528</p>
                  </div>
                  <div></div>
                </div>
                <div className="compony-info">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="30"
                      viewBox="0 -5 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 8.66699C9.10457 8.66699 10 7.77156 10 6.66699C10 5.56242 9.10457 4.66699 8 4.66699C6.89543 4.66699 6 5.56242 6 6.66699C6 7.77156 6.89543 8.66699 8 8.66699Z"
                        stroke="#C1C1C1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.00008 1.3335C6.58559 1.3335 5.22904 1.8954 4.22885 2.89559C3.22865 3.89579 2.66675 5.25234 2.66675 6.66683C2.66675 7.92816 2.93475 8.7535 3.66675 9.66683L8.00008 14.6668L12.3334 9.66683C13.0654 8.7535 13.3334 7.92816 13.3334 6.66683C13.3334 5.25234 12.7715 3.89579 11.7713 2.89559C10.7711 1.8954 9.41457 1.3335 8.00008 1.3335V1.3335Z"
                        stroke="#C1C1C1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    دبیرخـــانه: تهران، میدان فردوسی، خـیابان شهیـــد
                    قـــــــــرنی، ساختمان شـــماره ۲ وزارت آموزش و پرورش
                    (علاقمندان)، طبقه دوم
                    {/* آدرس:{" "}
                                        <span
                                            style={{ fontSize: "15px" }}
                                            className="number-font"
                                        >
                                            {siteSetting.address}
                                        </span> */}
                  </p>
                </div>
                <div className="compony-info">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="30"
                      viewBox="0 -5 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 8.66699C9.10457 8.66699 10 7.77156 10 6.66699C10 5.56242 9.10457 4.66699 8 4.66699C6.89543 4.66699 6 5.56242 6 6.66699C6 7.77156 6.89543 8.66699 8 8.66699Z"
                        stroke="#C1C1C1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.00008 1.3335C6.58559 1.3335 5.22904 1.8954 4.22885 2.89559C3.22865 3.89579 2.66675 5.25234 2.66675 6.66683C2.66675 7.92816 2.93475 8.7535 3.66675 9.66683L8.00008 14.6668L12.3334 9.66683C13.0654 8.7535 13.3334 7.92816 13.3334 6.66683C13.3334 5.25234 12.7715 3.89579 11.7713 2.89559C10.7711 1.8954 9.41457 1.3335 8.00008 1.3335V1.3335Z"
                        stroke="#C1C1C1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    دفتر فـــروش: تــــهران، خـــیابان حـــــــــافظ خیابان
                    رشــــــت، پلاک ۲۳، سوره مــــــــهر
                    {/* آدرس:{" "}
                                        <span
                                            style={{ fontSize: "15px" }}
                                            className="number-font"
                                        >
                                            {siteSetting.address}
                                        </span> */}
                  </p>
                </div>
                <div className="compony-info desktop-hidden ">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <path
                        d="M14.2222 3.40918H1.7778C1.54206 3.40918 1.31596 3.49857 1.14927 3.6577C0.982567 3.81682 0.888916 4.03263 0.888916 4.25766V12.7425C0.888916 12.9675 0.982567 13.1834 1.14927 13.3425C1.31596 13.5016 1.54206 13.591 1.7778 13.591H14.2222C14.458 13.591 14.6841 13.5016 14.8508 13.3425C15.0175 13.1834 15.1111 12.9675 15.1111 12.7425V4.25766C15.1111 4.03263 15.0175 3.81682 14.8508 3.6577C14.6841 3.49857 14.458 3.40918 14.2222 3.40918ZM13.5378 12.7425H2.51558L5.62669 9.671L4.98669 9.0813L1.7778 12.2504V4.90251L7.30225 10.1504C7.46879 10.3084 7.69408 10.3971 7.92892 10.3971C8.16375 10.3971 8.38904 10.3084 8.55558 10.1504L14.2222 4.771V12.1952L10.9511 9.07282L10.3245 9.671L13.5378 12.7425ZM2.36003 4.25766H13.5022L7.92892 9.54797L2.36003 4.25766Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    پست الکترونیک:
                    <span className="site-setting">{siteSetting.email}</span>
                  </p>
                </div>
              </div>
              <div className="Landing_main-seventeenth-section-right-bottom-left">
                <div className="Landing_main-seventeenth-section-right-bottom-left-top">
                  <div className="img-wrapper">
                    {/* <img src="/imgs/Landing/Mask.svg" /> */}
                    <img
                      referrerpolicy="origin"
                      id="rgvjwlaojxlzfukzjzpergvj"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          "https://logo.samandehi.ir/Verify.aspx?id=341673&p=xlaoaodsrfthgvkajyoexlao",
                          "Popup",
                          "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                        )
                      }
                      alt="logo-samandehi"
                      src="https://logo.samandehi.ir/logo.aspx?id=341673&p=qftishwlnbpdwlbqyndtqfti"
                    />
                  </div>
                  {/* <div className="img-wrapper">
                    <img src="/imgs/Landing/nemad.svg" />
                  </div> */}
                  <div className="img-wrapper">
                    <a
                      referrerpolicy="origin"
                      target="_blank"
                      href="https://trustseal.enamad.ir/?id=306340&amp;Code=YsWKYqxrreEC5BNneOEi"
                    >
                      <img
                        referrerpolicy="origin"
                        src="https://Trustseal.eNamad.ir/logo.aspx?id=306340&amp;Code=YsWKYqxrreEC5BNneOEi"
                        alt="logo-enamad"
                        id="YsWKYqxrreEC5BNneOEi"
                      />
                    </a>
                  </div>
                </div>
                <div className="Landing_main-seventeenth-section-right-bottom-left-bottom  mobile-hidden">
                  <img src="/imgs/Landing/green.svg" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer className="Landing_footer">
        <p className="footer-text">
          کلیه حقوق متعلق به <i className="text-purple">کتابنو</i> است
        </p>
      </footer>
    </Fragment>
  );
};

export default Landing;
